import { Schema as S } from "effect";
export const Schema = S.Literal("app-store");
export const Value = "app-store";
